var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "loading-bar rounded-border",
      staticStyle: {
        display: "flex",
        "flex-direction": "column",
        padding: "20px",
        width: "inherit",
        height: "max-content",
        margin: "10px"
      }
    },
    [
      _c(
        "span",
        {
          staticStyle: {
            display: "flex",
            color: "#003333",
            "justify-content": "center",
            "align-items": "center",
            "margin-bottom": "20px"
          }
        },
        [_vm._v(_vm._s(_vm.loadingText || "Loading..."))]
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-row",
                {
                  staticClass: "rounded-border",
                  staticStyle: {
                    height: "150px",
                    width: "100%",
                    "background-color": "#cccccc",
                    "margin-bottom": "10px"
                  }
                },
                [_c("el-col", { attrs: { span: 24 } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticClass: "rounded-border",
                  staticStyle: {
                    height: "20px",
                    width: "100%",
                    "background-color": "#cccccc",
                    "margin-bottom": "10px"
                  }
                },
                [_c("el-col", { attrs: { span: 24 } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticClass: "rounded-border",
                  staticStyle: {
                    height: "20px",
                    width: "100%",
                    "background-color": "#cccccc",
                    "margin-bottom": "10px"
                  }
                },
                [_c("el-col", { attrs: { span: 24 } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticClass: "rounded-border",
                  staticStyle: {
                    height: "20px",
                    width: "100%",
                    "background-color": "#cccccc",
                    "margin-bottom": "10px"
                  }
                },
                [_c("el-col", { attrs: { span: 24 } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticClass: "rounded-border",
                  staticStyle: {
                    height: "150px",
                    width: "100%",
                    "background-color": "#cccccc",
                    "margin-bottom": "10px"
                  }
                },
                [_c("el-col", { attrs: { span: 24 } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticClass: "rounded-border",
                  staticStyle: {
                    height: "20px",
                    width: "100%",
                    "background-color": "#cccccc",
                    "margin-bottom": "10px"
                  }
                },
                [_c("el-col", { attrs: { span: 24 } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticClass: "rounded-border",
                  staticStyle: {
                    height: "20px",
                    width: "100%",
                    "background-color": "#cccccc",
                    "margin-bottom": "10px"
                  }
                },
                [_c("el-col", { attrs: { span: 24 } })],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                {
                  staticClass: "rounded-border",
                  staticStyle: {
                    height: "20px",
                    width: "100%",
                    "background-color": "#cccccc"
                  }
                },
                [_c("el-col", { attrs: { span: 24 } })],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0f3e7000", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f3e7000","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/loadingSkeleton.vue
// module id = null
// module chunks = 